import { render, staticRenderFns } from "./bathQrCodes2.vue?vue&type=template&id=2366f1a5"
import script from "./bathQrCodes2.vue?vue&type=script&lang=js"
export * from "./bathQrCodes2.vue?vue&type=script&lang=js"
import style0 from "./bathQrCodes2.vue?vue&type=style&index=0&id=2366f1a5&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports